module.exports = __webpack_public_path__ + "static/media/minus.fac9cb1f.png";